












































import { Component, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import PortalSearchBox from "@/components/portal/PortalOrganizationSearchBox.vue";
import { PortalSearchParams } from "@/components/portal/PortalOrganizationSearchBox.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import PortalOrganizationTable from "@/views/portal/PortalOrganizationTable.vue";

@Component({
  components: {
    AppTextField,
    PortalSearchBox,
    AppAuthButton,
    PortalOrganizationTable,
  },
})
export default class PortalOrganizationList extends Mixins(AxiosMixin) {
  private searchKey = ""; //絞り込み文字列

  /** タブ情報 */
  private currentTab = 0;

  private rejects = [];
  private reviewings = [];
  private organizations = [];

  //データ取得
  private fetchList(searchObj: PortalSearchParams): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/portal_organizations/get",
      searchObj,
      (res) => {
        this.organizations = res.data.organizations ?? [];
        this.rejects = res.data.reject_organizations ?? [];
        this.reviewings = res.data.reviewing_organizations ?? [];
      }
    );
  }

  /** 詳細ボタンクリック時 */
  private goDetail(id: number) {
    /** 詳細画面へ遷移 */
    this.$router.push({ path: `/portal/organization/detail/${id}` });
  }
}
